import api from '@/api/postApplicantManagement'

const state = {

}

const actions = {
  searchMicroSite ({ commit }, condition) {
    return api.searchMicroSite(condition)
  },
  getMicroSiteById ({ commit }, id) {
    return api.getMicroSiteById(id)
  },
  createMicroSite ({ commit }, microSite) {
    return api.createMicroSite(microSite)
  },
  updateMicroSite ({ commit }, microSite) {
    return api.updateMicroSite(microSite)
  },

  searchQuestion ({ commit }, condition) {
    return api.searchQuestion(condition)
  },
  getQuestionById ({ commit }, id) {
    return api.getQuestionById(id)
  },
  createQuestion ({ commit }, question) {
    return api.createQuestion(question)
  },
  updateQuestion ({ commit }, question) {
    return api.updateQuestion(question)
  },

  searchStep ({ commit }, condition) {
    return api.searchStep(condition)
  },
  getStepById ({ commit }, id) {
    return api.getStepById(id)
  },
  createStep ({ commit }, step) {
    return api.createStep(step)
  },
  updateStep ({ commit }, step) {
    return api.updateStep(step)
  },

  searchQuestionnaire ({ commit }, condition) {
    return api.searchQuestionnaire(condition)
  },
  getQuestionnaireById ({ commit }, id) {
    return api.getQuestionnaireById(id)
  },
  createQuestionnaire ({ commit }, step) {
    return api.createQuestionnaire(step)
  },
  updateQuestionnaire ({ commit }, step) {
    return api.updateQuestionnaire(step)
  },

  searchEmailTemplate ({ commit }, condition) {
    return api.searchEmailTemplate(condition)
  },
  getEmailTemplateById ({ commit }, id) {
    return api.getEmailTemplateById(id)
  },
  sendTestEmail ({ commit }, emailTemplate) {
    return api.sendTestEmail(emailTemplate)
  },
  updateEmailTemplate ({ commit }, emailTemplate) {
    return api.updateEmailTemplate(emailTemplate)
  },

  searchInvitation ({ commit }, condition) {
    return api.searchInvitation(condition)
  },
  updateInvitation ({ commit }, invitation) {
    return api.updateInvitation(invitation)
  },
  putInvitation ({ commit }, invitation) {
    return api.putInvitation(invitation)
  },
  exportInvitation ({ commit }, condition) {
    return api.exportInvitation(condition)
  },
  createInvitation (context, invitation) {
    return api.createInvitation(invitation)
  }
}

const mutations = {

}

const getters = {

}
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
